import { render, staticRenderFns } from "./dialogAddPositionLevelInGroup.vue?vue&type=template&id=2bbdda80&scoped=true"
import script from "./dialogAddPositionLevelInGroup.vue?vue&type=script&lang=js"
export * from "./dialogAddPositionLevelInGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbdda80",
  null
  
)

export default component.exports